export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70e3ff063e7d73fe36dd40a4e2bb5548c03817016f&name=pushAdClickData!'